import sliceCreator from '../../index.jsx';
import {GET_USER_BY_ID} from '../../../constants/index.jsx';
const _getUserByIdAction = sliceCreator('GET_USER_BY_ID', GET_USER_BY_ID, 'get');

const { asyncAction: getUserByIdAction, reducer, clearData: clearGetUserByIdAction } = _getUserByIdAction;

export default reducer;

export {
    getUserByIdAction,
    clearGetUserByIdAction
}